import { BookmarkAdd } from '@mui/icons-material';
import Add from '@mui/icons-material/Add';
import RecordVoice from '@mui/icons-material/RecordVoiceOver';
import { Box, Tooltip, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { blue, lightGreen, red, yellow } from '@mui/material/colors';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import { SITUACAO_INSCRICAO_ADVOGADO } from '@/dominio/SituacaoInscricaoAdvogado';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import Configuracao from '../../util/Configuracao';
import PopoverSecretaria from '../PopoverSecretaria';
import ReactComponent from '../ReactComponent';
import TableAdvogado from '../TableAdvogado';
import IconeAdvogado from './icones/IconeAdvogado';
import IconeAdvogadoParticipacaoVirtual from './icones/IconeAdvogadoParticipacaoVirtual';
import IconeAdvogadoSustentacaoOralTelepresencial from './icones/IconeAdvogadoSustentacaoOralTelepresencial';
import IconeAdvogadoSustentacaoOralEletronica from './icones/IconeAdvogadoSustentacaoOralEletronica';
import IconeAdvogadoPedidoDestaque from './icones/IconeAdvogadoPedidoDestaque';

class ParteAdvogados {
    constructor(codigoDaParte, denominacaoDaParte, nomeDaParte, advogados) {
        this.codigoDaParte = codigoDaParte;
        this.denominacaoDaParte = denominacaoDaParte;
        this.nomeDaParte = nomeDaParte;
        this.advogados = advogados;
    }
}

class ParticipacaoAdvogado extends ReactComponent {
    currentPopover = null;
    acabouDeFechar = false;
    pedidosEsijOriginal =
        !this.origemProcessoPJe &&
        this.observableProps.registro?.pedidoSustentacaoOral?.pedidosDetalhados &&
        this.observableProps.registro.pedidoSustentacaoOral.pedidosDetalhados.length > 0
            ? JSON.parse(JSON.stringify(this.observableProps.registro.pedidoSustentacaoOral.pedidosDetalhados))
            : null;
    disabled = false;
    tooltipPadrao = 'Pedidos de participações virtuais';
    label = '';

    /** @type {Object[] | null} */
    partesAdvogados = null;

    constructor(props) {
        super(props);

        makeObservable(this, {
            currentPopover: observable,
            acabouDeFechar: observable,
            pedidosEsijOriginal: observable,
            disabled: observable,
            tooltipPadrao: observable,
            label: observable,
            setLabel: action,
            sessao: computed,
            registro: computed,
            todosOsPedidosDoProcesso: computed,
            handleClose: action,
            handleAbrirPopover: action,
            adicionarAdvogado: action,
            atualizarListaPedidos: action,
            idIconeParticipacaoVirtual: computed,
            idIconeParticipacaoPresencial: computed,
            idIconeParticipacaoTelepresencial: computed,
            idIconeParticipacaoIndefinido: computed,
            idIconeSustentacaoOralEletronica: computed,
            idIconePedidoDestaque: computed,
            renderParticipacaoTelepresencial: computed,
            renderParticipacaoIndefinida: computed,
            renderParticipacaoVirtual: computed,
            renderParticipacaoPresencial: computed,
            renderSustentacaoOralEletronica: computed,
            renderPedidoDestaque: computed
        });
    }

    componentDidMount() {
        this.setLabel();
    }

    setLabel() {
        if (this.parametroStore.isOrgaoTST) {
            this.label = 'Inscrição para sessão de julgamento presencial (preferência/sustentação oral)';
        } else {
            this.label = 'Inscrição para sustentação oral presencial';
        }
    }

    get sessao() {
        return this.sessaoStore.sessaoSelecionada;
    }

    get origemProcessoPJe() {
        return this.observableProps.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get todosOsPedidosDoProcesso() {
        if (
            !this.registro?.pedidoSustentacaoOral?.pedidosDetalhados ||
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.length === 0
        ) {
            return null;
        }

        return this.registro.pedidoSustentacaoOral;
    }

    temPartipacao(modoParticipacao) {
        return (
            this.registro?.pedidoSustentacaoOral?.pedidosDetalhados &&
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.length > 0 &&
            this.registro.pedidoSustentacaoOral.pedidosDetalhados.some((pedido) => {
                return (
                    pedido.advogados &&
                    pedido.advogados.some((advogado) => {
                        return !!(advogado.modoParticipacao && advogado.modoParticipacao === modoParticipacao);
                    })
                );
            })
        );
    }

    advogadosComParticipacao(modoParticipacao) {
        this.partesAdvogados = [];

        this.todosOsPedidosDoProcesso.pedidosDetalhados &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados.forEach((pedido) => {
                let parteAdvogados = new ParteAdvogados();

                parteAdvogados.codigoDaParte = pedido.codigoDaParte;
                parteAdvogados.denominacaoDaParte = pedido.denominacaoDaParte;
                parteAdvogados.nomeDaParte = pedido.nomeDaParte;
                parteAdvogados.advogados = [];

                pedido.advogados &&
                    pedido.advogados.forEach((adv) => {
                        if (adv.modoParticipacao && adv.modoParticipacao === modoParticipacao) {
                            parteAdvogados.advogados.push(adv);
                        }
                    });

                if (parteAdvogados.advogados.length > 0) {
                    this.partesAdvogados?.push(parteAdvogados);
                }
            });

        return this.partesAdvogados;
    }

    totalAdvogadosComParticipacao(modoParticipacao) {
        let total = 0;

        let advogados = this.advogadosComParticipacao(modoParticipacao);

        advogados.forEach((parteAdvogados) => {
            if (parteAdvogados.advogados) {
                total += parteAdvogados.advogados.length;
            }
        });

        return total;
    }

    handleClose = () => {
        this.acabouDeFechar = true;

        setTimeout(() => {
            runInAction(() => {
                this.acabouDeFechar = false;
            });
        }, 10);

        this.currentPopover = null;
        this.editarPedido = false;
        this.disabled = false;
    };

    handleAbrirPopover = (idIcone) => {
        if (!this.acabouDeFechar) {
            this.currentPopover = idIcone;
        }
    };

    adicionarAdvogado = (pedido) => {
        pedido.advogados.push({});
    };

    atualizarListaPedidos = () => {
        const todosOsPedidos = this.todosOsPedidosDoProcesso;

        if (todosOsPedidos) {
            this.pedidosEsijOriginal = JSON.parse(JSON.stringify(todosOsPedidos.pedidosDetalhados));
        } else {
            this.pedidosEsijOriginal = null;
        }
    };

    contabilizarPresencas(modoParticipacao) {
        let totalPresentes = 0;
        let totalAusentes = 0;
        let totalNA = 0;

        if (
            this.todosOsPedidosDoProcesso &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados &&
            this.todosOsPedidosDoProcesso.pedidosDetalhados.length !== 0
        ) {
            this.todosOsPedidosDoProcesso.pedidosDetalhados.forEach((pedido) => {
                pedido.advogados &&
                    pedido.advogados.forEach((adv) => {
                        if (adv.modoParticipacao === modoParticipacao) {
                            switch (adv.presente) {
                                case SITUACAO_INSCRICAO_ADVOGADO.PRESENTE.codigo:
                                    totalPresentes++;
                                    break;
                                case SITUACAO_INSCRICAO_ADVOGADO.AUSENTE.codigo:
                                    totalAusentes++;
                                    break;
                                case SITUACAO_INSCRICAO_ADVOGADO.INSCRITO.codigo:
                                    totalNA++;
                                    break;
                                default:
                                    break;
                            }
                        }
                    });
            });
        }

        return { totalAusentes, totalPresentes, totalNA };
    }

    corConjuntoPresencasAdvogadosProcesso(modoParticipacao) {
        let { totalAusentes, totalPresentes, totalNA } = this.contabilizarPresencas(modoParticipacao);

        if (totalPresentes > 0) {
            if (totalAusentes > 0) {
                return yellow[900];
            } else {
                return lightGreen[800];
            }
        } else if (totalAusentes > 0) {
            return red[900];
        } else if (totalNA > 0) {
            return 'black';
        }

        return 'gray';
    }

    get idIconeParticipacaoVirtual() {
        return 'iconeParticipacaoVirtual' + this.registro.numeroProcesso;
    }

    get idIconeParticipacaoPresencial() {
        return 'iconeSustentacaoOral' + this.registro.numeroProcesso;
    }

    get idIconeParticipacaoTelepresencial() {
        return 'iconeParticipacaoVideoconferencia' + this.registro.numeroProcesso;
    }

    get idIconeParticipacaoIndefinido() {
        return 'iconeParticipacaoIndefinido' + this.registro.numeroProcesso;
    }

    get idIconeSustentacaoOralEletronica() {
        return 'idIconeSustentacaoOralEletronica' + this.registro.numeroProcesso;
    }

    get idIconePedidoDestaque() {
        return 'idIconePedidoDestaque' + this.registro.numeroProcesso;
    }

    render() {
        return (
            <Box
                display="flex"
                alignItems="center"
                justifyContent="flex-end"
            >
                {this.renderParticipacaoIndefinida}
                {this.renderParticipacaoTelepresencial}
                {this.renderParticipacaoVirtual}
                {this.renderParticipacaoPresencial}
                {this.renderSustentacaoOralEletronica}
                {this.renderPedidoDestaque}
            </Box>
        );
    }

    get renderParticipacaoTelepresencial() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconeParticipacaoTelepresencial)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="15px"
                    width="28px"
                >
                    <IconeAdvogadoSustentacaoOralTelepresencial
                        id={this.idIconeParticipacaoTelepresencial}
                        sx={{
                            fill: this.corConjuntoPresencasAdvogadosProcesso(
                                MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo
                            ),
                            fillOpacity: '1'
                        }}
                    />
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo) > 1 && (
                        <Add
                            id={'add' + this.idIconeParticipacaoTelepresencial}
                            style={{
                                fillOpacity: '1',
                                width: '11px',
                                height: '11px',
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo
                                )
                            }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconeParticipacaoTelepresencial,
                        MODO_PARTICIPACAO_ADVOGADO.TELEPRESENCIAL.codigo
                    )}
                </Box>
            )
        );
    }

    get renderParticipacaoIndefinida() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconeParticipacaoIndefinido)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="15px"
                    fontSize="20px"
                >
                    <IconeAdvogado
                        tooltip={'Pedido de participação indefinido'}
                        removerEstiloPadrao
                        id={this.idIconeParticipacaoIndefinido}
                        style={{
                            fill: this.corConjuntoPresencasAdvogadosProcesso(
                                MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo
                            ),
                            fillOpacity: '1'
                        }}
                    />
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo) > 1 && (
                        <Add
                            id={'add' + this.idIconeParticipacaoIndefinido}
                            style={{
                                fillOpacity: '1',
                                width: '11px',
                                height: '11px',
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo
                                )
                            }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconeParticipacaoTelepresencial,
                        MODO_PARTICIPACAO_ADVOGADO.INDEFINIDO.codigo
                    )}
                </Box>
            )
        );
    }

    get renderParticipacaoVirtual() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconeParticipacaoVirtual)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="10px"
                    width="28px"
                >
                    <IconeAdvogadoParticipacaoVirtual
                        tooltip={this.tooltipPadrao}
                        removerEstiloPadrao
                        id={this.idIconeParticipacaoVirtual}
                    />
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) > 1 && (
                        <Add
                            id={'add' + this.idIconeParticipacaoVirtual}
                            style={{ fillOpacity: '1', width: '11px', height: '11px' }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconeParticipacaoVirtual,
                        MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo
                    )}
                </Box>
            )
        );
    }

    get renderParticipacaoPresencial() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconeParticipacaoPresencial)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="10px"
                    width="25px"
                >
                    <Tooltip title={this.label}>
                        <RecordVoice
                            id={this.idIconeParticipacaoPresencial}
                            style={{
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo
                                ),
                                fillOpacity: '1'
                            }}
                        />
                    </Tooltip>
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo) > 1 && (
                        <Add
                            id={'add' + this.idIconeParticipacaoPresencial}
                            style={{
                                fillOpacity: '1',
                                width: '11px',
                                height: '11px',
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo
                                )
                            }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconeParticipacaoPresencial,
                        MODO_PARTICIPACAO_ADVOGADO.PRESENCIAL.codigo
                    )}
                </Box>
            )
        );
    }

    get renderSustentacaoOralEletronica() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconeSustentacaoOralEletronica)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="10px"
                    width="25px"
                >
                    <IconeAdvogadoSustentacaoOralEletronica
                        tooltip={this.tooltipPadrao}
                        removerEstiloPadrao
                        id={this.idIconeSustentacaoOralEletronica}
                    />
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo) >
                        1 && (
                        <Add
                            id={'add' + this.idIconeSustentacaoOralEletronica}
                            style={{
                                fillOpacity: '1',
                                width: '11px',
                                height: '11px',
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                                )
                            }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconeSustentacaoOralEletronica,
                        MODO_PARTICIPACAO_ADVOGADO.SUSTENTACAO_ORAL_ELETRONICA.codigo
                    )}
                </Box>
            )
        );
    }

    get renderPedidoDestaque() {
        return (
            this.temPartipacao(MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo) && (
                <Box
                    onClick={() => this.handleAbrirPopover(this.idIconePedidoDestaque)}
                    style={{ cursor: 'pointer' }}
                    display="flex"
                    marginRight="10px"
                    width="25px"
                >
                    <IconeAdvogadoPedidoDestaque
                        tooltip={this.tooltipPadrao}
                        removerEstiloPadrao
                        id={this.idIconePedidoDestaque}
                    />
                    {this.totalAdvogadosComParticipacao(MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo) > 1 && (
                        <Add
                            id={'add' + this.idIconePedidoDestaque}
                            style={{
                                fillOpacity: '1',
                                width: '11px',
                                height: '11px',
                                fill: this.corConjuntoPresencasAdvogadosProcesso(
                                    MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo
                                )
                            }}
                        />
                    )}
                    {this.renderPopoverSecretaria(
                        this.idIconePedidoDestaque,
                        MODO_PARTICIPACAO_ADVOGADO.PEDIDO_DESTAQUE.codigo
                    )}
                </Box>
            )
        );
    }

    abrirPopover(idIcone) {
        return this.currentPopover === idIcone;
    }

    renderPopoverSecretaria(idIcone, modoParticipacao) {
        const abrir = this.abrirPopover(idIcone);
        if (!abrir) {
            return null;
        }
        return (
            <PopoverSecretaria
                open={abrir}
                onClose={this.handleClose}
                placement="right"
                anchorEl={() => document.getElementById(idIcone)}
            >
                <List style={{ maxWidth: '500px' }}>
                    <ListItem>
                        <span style={{ whiteSpace: 'pre-line' }}>
                            {this.renderPedidosParticipacao(modoParticipacao)}
                        </span>
                    </ListItem>
                </List>
            </PopoverSecretaria>
        );
    }

    renderPedidosParticipacao(modoParticipacao) {
        let advogados = this.advogadosComParticipacao(modoParticipacao);

        return this.todosOsPedidosDoProcesso.pedidosDetalhados !== undefined && this.temPartipacao(modoParticipacao) ? (
            advogados.map((pedido, indexPedido) => {
                return (
                    <Box
                        key={'pedido' + indexPedido}
                        style={{
                            marginBottom:
                                this.todosOsPedidosDoProcesso.pedidosDetalhados.length - 1 !== indexPedido ? '10px' : 0
                        }}
                    >
                        <Typography style={{ color: blue[900], fontWeight: 'bold' }}>
                            {pedido.denominacaoDaParte
                                ? pedido.denominacaoDaParte + ': '
                                : '(Denominação não informada) '}
                            {pedido.nomeDaParte}
                        </Typography>
                        {pedido.advogados.map((advogado) => {
                            return (
                                <TableAdvogado
                                    advogado={advogado}
                                    key={this.nextKey}
                                />
                            );
                        })}
                    </Box>
                );
            })
        ) : (
            <Box>{this.todosOsPedidosDoProcesso.descricaoAdvogado}</Box>
        );
    }
}

export default inject('stores')(observer(ParticipacaoAdvogado));
